import { render, staticRenderFns } from "./StageCreateUpdate.vue?vue&type=template&id=ad96c740&scoped=true&"
import script from "./StageCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./StageCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./StageCreateUpdate.vue?vue&type=style&index=0&id=ad96c740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad96c740",
  null
  
)

export default component.exports